module.exports = __webpack_public_path__ + "pay.72624223.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/community_tabs/pay.png
// module id = 193
// module chunks = 0